__turbopack_context__.v({
  "drawer": "drawer-module-scss-module__k0yStG__drawer",
  "drawer-wrapper": "drawer-module-scss-module__k0yStG__drawer-wrapper",
  "drawer__actions": "drawer-module-scss-module__k0yStG__drawer__actions",
  "drawer__close-button": "drawer-module-scss-module__k0yStG__drawer__close-button",
  "fadeIn": "drawer-module-scss-module__k0yStG__fadeIn",
  "slideIn": "drawer-module-scss-module__k0yStG__slideIn",
});
